import React, { useState } from 'react';
import { Badge } from '../../components/ui/badge';
import { ChevronRight, ChevronDown, Layers, Building2, GraduationCap, BookOpen, FlaskConical, Briefcase } from 'lucide-react';

const LABELS = {
  rectorate: 'Rectorat', direction: 'Direction', faculty: 'Faculte', section: 'Section',
  department: 'Departement', program: 'Programme', center: 'Centre', service: 'Service',
  library: 'Bibliotheque', laboratory: 'Laboratoire', clinic: 'Clinique', other: 'Autre'
};
const ICONS = {
  rectorate: Building2, direction: Building2, faculty: GraduationCap,
  department: Layers, center: FlaskConical, service: Briefcase, program: BookOpen,
};

function flattenTree(nodes, level, expanded) {
  const result = [];
  for (const node of nodes) {
    const kids = node.children || [];
    result.push({ ...node, level, hasChildren: kids.length > 0 });
    if (kids.length > 0 && expanded[node.id]) {
      result.push(...flattenTree(kids, level + 1, expanded));
    }
  }
  return result;
}

export const OrgTree = ({ tree, onSelect, selectedId }) => {
  const [expanded, setExpanded] = useState(() => {
    const init = {};
    (tree || []).forEach(n => { init[n.id] = true; });
    return init;
  });

  const toggle = (id) => setExpanded(prev => ({ ...prev, [id]: !prev[id] }));
  const flat = flattenTree(tree || [], 0, expanded);

  return (
    <div>
      {flat.map(node => {
        const Icon = ICONS[node.type] || Layers;
        const sel = selectedId === node.id;
        return (
          <div key={node.id}
            className={`flex items-center gap-2 py-1.5 px-2 rounded cursor-pointer ${sel ? 'bg-blue-50 text-blue-700' : 'hover:bg-gray-50'}`}
            style={{ paddingLeft: node.level * 20 + 8 }}
            onClick={() => onSelect(node)}
            data-testid={`tree-node-${node.id}`}
          >
            {node.hasChildren ? (
              <button onClick={e => { e.stopPropagation(); toggle(node.id); }} className="w-4 h-4 text-gray-400 flex-shrink-0">
                {expanded[node.id] ? <ChevronDown className="w-3.5 h-3.5" /> : <ChevronRight className="w-3.5 h-3.5" />}
              </button>
            ) : <span className="w-4 flex-shrink-0" />}
            <Icon className="w-4 h-4 text-gray-500 flex-shrink-0" />
            <span className="text-sm truncate flex-1">{node.name}</span>
            <Badge variant="outline" className="text-[10px] px-1.5 py-0 h-5 flex-shrink-0">{LABELS[node.type] || node.type}</Badge>
          </div>
        );
      })}
    </div>
  );
};
